import React from "react";
import { Row, Col, Card, CardBody, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Charts
import ProfitChart from "../AllCharts/echart/LineChart2";
import DebtorsDay from "pages/AllCharts/echart/DebtorsDay";
import CreditorsDay from "pages/AllCharts/echart/CreditorsDay";
import DebtCredt from "pages/AllCharts/echart/DebtCredt";
import RevnewProfit from "pages/AllCharts/echart/RevnewProfit";
import CashFlowIndi from "pages/AllCharts/echart/CashFlowIndi";
import IndusBenchMark from "pages/AllCharts/echart/IndusBenchMark";
import WorkingCapitalChart from "pages/AllCharts/echart/WorkingCapitalChart";

const EChart = () => {
  document.title = "ECharts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumb */}
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="ECharts" />

          <Row>

            <Col lg="6">
              <Card>
                <CardBody>
                  {/* <h4 className="mt-0 header-title mb-4">Industrial Benchmark Indicators</h4> */}
                  <div id="bubble-chart" className="e-chart">
                    <IndusBenchMark />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Creditors' Day Outstanding</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CreditorsDay />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Debtors and Creditors</h4>
                  <div id="Debtors and Creditors" className="e-chart">
                    <DebtCredt />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Revenue and Profit</h4>
                  <div id="DebetorsDayOutStanding" className="e-chart">
                    <RevnewProfit />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Days Outstanding</h4>
                  <div id="line-chart" className="e-chart">
                    <DebtorsDay />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Cash Flow Indicators</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CashFlowIndi />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Working Capital</h4>
                  <div id="doughnut-chart" className="e-chart">
                    <WorkingCapitalChart/>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>


        </Container>
      </div>
    </React.Fragment>
  );
};

export default EChart;
